export default "__VITE_ASSET__BeZKh6zR__"